import { InfoCard, LinkButton } from '@backstage/core-components';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import {
  DevcontainersProvider,
  useDevcontainers,
} from '../plugin';

const DevcontainersCardContent = () => {
  const state = useDevcontainers();

  if (!state.hasUrl) {
    return null;
  }

  return (
    <InfoCard title="Development Environment">
      <LinkButton
        to={state.vsCodeUrl}
        color="primary"
        variant="contained"
      >
        Open in VS Code
      </LinkButton>
    </InfoCard>
  );
};

const DevcontainersCard = () => (
  <DevcontainersProvider
    config={{
      tagName: 'devcontainers',
    }}
  >
    <DevcontainersCardContent />
  </DevcontainersProvider>
);

export const devcontainersEntityCard = EntityCardBlueprint.make({
  name: 'devcontainers',
  params: {
    loader: async () => <DevcontainersCard />,
  },
});